import { useContext } from 'react';
import { policyAnalyticsState } from '../providers';

const usePolicyAnalytics = () => {
  const context = useContext(policyAnalyticsState);
  if (!context) {
    throw new Error('context not initialized');
  }
  return context;
};

export default usePolicyAnalytics;
